import { authStateManagerService } from '@/infra';
import { redirect } from 'react-router-dom';

/**
 * Guard para proteger rutas públicas y prevenir acceso de usuarios autenticados.
 *
 * Funcionalidad:
 * - Se ejecuta ANTES del renderizado del componente para evitar flash de contenido
 * - Verifica si el usuario ya está autenticado y lo redirige al home
 *
 * Responsabilidades:
 * - Verificar el estado de autenticación del usuario mediante authStateManagerService
 * - Redirigir al home (/) si el usuario ya está autenticado
 * - Permitir acceso a la ruta pública si el usuario no está autenticado
 */
export const publicRouteGuard = () => {
  if (authStateManagerService.isUserAuthenticated()) throw redirect('/');

  return null;
};
